




























































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectDaysComponent from '@/components/SelectDaysComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import DateAndUserPickerDialogComponent from '@/components/DateAndUserPickerDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import DatePickerDialogComponent from '@/components/DatePickerDialogComponent.vue'
import { Report, MailQueue } from '@/domain/Report'
import { SendMail } from '@/domain/SendMail'
import { WindowPosition } from '@/domain/WindowPosition'
import ReportsService, { SerchConditon } from '@/service/ReportsService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectDaysComponent,
    CustomerSelectDialogComponent,
    DateAndUserPickerDialogComponent,
    PdfViewComponent,
    SendMailDialogComponent,
    DatePickerDialogComponent,
  },
})
export default class MemberReportList extends Mixins(GlobalMixin) {
  reportsService = ReportsService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "報告日", value: "reportOn", width: "100px" },
          { text: "受付番号", value: "requestNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体名", value: "specimenName", width: "180px" },
          { text: "検体識別記号", value: "specimenId", width: "130px" },
          { text: "検査名称", value: "inspectionNames" },
          { text: "メール", value: "mailSendAt", align: "center", filterable: false, width: "100px" },
          { text: "郵送", value: "postSendOn", align: "center", filterable: false, width: "100px" },
          { text: "FAX", value: "faxSendOn", align: "center", filterable: false, width: "100px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "200px" },
  ]
  list: Report[] = []
  selectItems: Report[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""

  itemKey = ""
  mailSendReportNos: string[] = []
  sendMail = new SendMail()

  postSendReportNos: string[] = []
  postDatePickerDialog = false
  faxSendReportNos: string[] = []
  faxDatePickerDialog = false

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    const keys = this.selectItems.map(x => `${x.customerInfo.customerPrefectureCode}:${x.customerInfo.customerCode}:${x.customerInfo.customerBranchNumber}:${x.agencyInfo.agencyPrefectureCode}:${x.agencyInfo.agencyCode}:${x.agencyInfo.agencyBranchNumber}:${x.requestType}`)
    const distinct = [...new Set(keys)]
    return distinct.length === 1
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.report.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.report.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.report.list.conditions", JSON.stringify(this.conditions))
    this.reportsService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        this.mountedDataTable("tool.report.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Report): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Report) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.reportNo) {
      this.$router.push(`/member/report/edit/${event.reportNo}`)
    }
    this.rowItemKey = event.reportNo
    this.rowItemClickTime = now
  }

  /**
   * メール一括送信ボタンのクリック
   */
  onMail() {
    const reportNos = this.selectItems.map(x => x.reportNo)
    this.onSendMail(reportNos)
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail(reportNos: string[]) {
    this.mailSendReportNos = reportNos
    this.reportsService.generateMailTemplate(this.mailSendReportNos)
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, reportNos: this.mailSendReportNos})
    this.reportsService.mailQueuePush(mailQueue)
      .then((x) => {
          this.list.filter(y => mailQueue.reportNos.indexOf(y.reportNo) >= 0)
            .forEach(y => y.mailSendAt = x.mailSendAt)
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 一括郵送ボタンのクリック
   */
  onPost() {
    const reportNos = this.selectItems.map(x => x.reportNo)
    this.onSendPost(reportNos)
  }

  /**
   * 郵送ボタンのクリック
   */
  onSendPost(reportNos: string[]) {
    this.postSendReportNos = reportNos
    this.postDatePickerDialog = true
  }

  /**
   * 報告書郵送
   */
  onSendPosted(event: string) {
    this.showLoading()
    this.reportsService.sendPost(this.postSendReportNos, event)
      .then(() => {
          this.list.filter(x => this.faxSendReportNos.indexOf(x.reportNo) >= 0)
            .forEach(y => y.postSendOn = event)
          this.alert("報告書郵送日を更新しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("報告書郵送日の更新に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * FAX一括送信ボタンのクリック
   */
  onFax() {
    const reportNos = this.selectItems.map(x => x.reportNo)
    this.onSendFax(reportNos)
  }

  /**
   * FAX送信ボタンのクリック
   */
  onSendFax(reportNos: string[]) {
    this.faxSendReportNos = reportNos
    this.faxDatePickerDialog = true
  }

  /**
   * 報告書FAX送信
   */
  onSendFaxed(event: string) {
    this.showLoading()
    this.reportsService.sendFax(this.faxSendReportNos, event)
      .then(() => {
          this.list.filter(x => this.faxSendReportNos.indexOf(x.reportNo) >= 0)
            .forEach(y => y.faxSendOn = event)
          this.alert("報告書FAX送信日を更新しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("報告書FAX送信日の更新に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.report.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.report.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.report.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
